import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";
import Button from "common/Buttons/Button";
import React from "react";
import styled from "styled-components";
import { HEADER_HEIGHT } from "common/Home/General/constants.tsx";
import { useEmptyState } from "common/Icons/useEmptyState.tsx";
import useMedia from "utils/hooks/useMedia.ts";
import { MOBILE_SEARCH } from "common/constants.ts";
import { useTranslation } from "react-i18next";
import { LanguageNameSpaces } from "@shared/types";

interface QueriesErrorProps {
  refetchErrorQueries?: () => void;
  isGeneralPageError?: boolean;
  description?: string;
}

const QueriesError = ({
  refetchErrorQueries,
  isGeneralPageError,
  description: propsDescription,
}: QueriesErrorProps) => {
  const { Gears } = useEmptyState();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { t } = useTranslation(LanguageNameSpaces.COMMON, {
    useSuspense: false,
  });

  const description =
    propsDescription ??
    (isGeneralPageError
      ? t("errors.click_to_reload")
      : t("errors.click_to_try_again"));

  const onButtonClick = () => {
    if (refetchErrorQueries) refetchErrorQueries();
    else if (isGeneralPageError) {
      window.location.reload();
    }
  };

  return (
    <ErrorWrapper>
      <div style={{ textAlign: "center" }}>
        <Gears
          style={{
            height: isMobile ? 130 : 170,
            width: "100%",
            marginBottom: 24,
          }}
        />
        <Text $weight={typography.fontWeights.MEDIUM} $size={"XL"}>
          {t("errors.something_went_wrong")}
        </Text>
        <Text type="secondary" style={{ marginTop: 4 }}>
          {description}
        </Text>
        <Button
          type="primary"
          onClick={onButtonClick}
          style={{
            marginTop: 16,
            alignSelf: "stretch",
            height: 40,
            width: 260,
          }}
        >
          {isGeneralPageError ? t("errors.reload_page") : t("errors.try_again")}
        </Button>
      </div>
    </ErrorWrapper>
  );
};

export default QueriesError;

const ErrorWrapper = styled.div`
  display: flex;
  background-color: ${(p) => p.theme.colors.layoutBgColor};
  height: calc(100vh - ${HEADER_HEIGHT}px);
  justify-content: center;
  align-items: center;
`;
